module.exports = __webpack_public_path__ + "fonts/prompt-v4-thai_latin-700.429e7a67.woff";